var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.75 35.01H3.25999C1.45999 35.01 0 33.55 0 31.75V3.26C0 1.46 1.45999 0 3.25999 0H11.8C12.82 0 13.8 0.489998 14.41 1.31L16.98 4.14C17.29 4.56 17.7 4.76 18.13 4.76H31.73C33.53 4.76 34.99 6.22 34.99 8.02V31.74C34.99 33.54 33.53 35 31.73 35L31.75 35.01ZM3.25999 1.9C2.50999 1.9 1.89999 2.51 1.89999 3.27V31.76C1.89999 32.51 2.50999 33.12 3.25999 33.12H31.75C32.5 33.12 33.12 32.51 33.12 31.76V8.04C33.12 7.29 32.51 6.68 31.75 6.68H18.15C17.13 6.68 16.15 6.19 15.54 5.37L12.97 2.54C12.66 2.12 12.25 1.92 11.82 1.92H3.28L3.25999 1.9Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.51 28.3901C16.73 28.3901 16.09 27.7501 16.09 26.9701V12.7801C16.09 12.0001 16.73 11.3601 17.51 11.3601C18.29 11.3601 18.93 12.0001 18.93 12.7801V26.9701C18.93 27.7501 18.29 28.3901 17.51 28.3901Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.61 21.2902H10.42C9.64 21.2902 9 20.6502 9 19.8702C9 19.0902 9.64 18.4502 10.42 18.4502H24.61C25.39 18.4502 26.03 19.0902 26.03 19.8702C26.03 20.6502 25.39 21.2902 24.61 21.2902Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderAdd);
export default __webpack_public_path__ + "static/media/folder_add.e6724c199784ef70349ef0e110834240.svg";
export { ForwardRef as ReactComponent };